import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { environment } from '../../environments/environment';

import 'rxjs/add/operator/toPromise';

import { InvoiceInfo } from '../models/invoice-info';

@Injectable()
export class InvoiceService {

  private headers = new HttpHeaders({'Content-Type': 'application/json'});

  constructor(private http: HttpClient) { }

  getInvoiceInfo(invoiceToken: string, ChamberID: string): Promise<any> {
    return this.http.get<InvoiceInfo>(environment.apiURL + 'Invoice/' + invoiceToken + '?chamberid=' + ChamberID)
    .toPromise()
    .then(response => response)
    .catch(error => Promise.reject('Désolé! La facture est introuvable...'));
  }

  findInvoice(chamberId: string, invoiceNumber: string, accountNumber: string, chapter: string|null, referenceType: string|null): Promise<any> {
    let url: string = environment.apiURL + 'Invoice/Find?chamberid=' + chamberId + '&invoicenumber=' + invoiceNumber + '&accountnumber=' + accountNumber;
    if (chapter) {
      url += '&chapter=' + chapter;
    }
    if (referenceType) {
      url += '&reftype=' + referenceType;
    }

    return this.http.get<string>(url)
    .toPromise()
    .then(response => response)
    .catch(error => Promise.reject('Désolé! La facture est introuvable...'));
  }

  getInvoicePDF(invoiceId: string, chamberId: string): Promise<any> {
    const callHeaders = new HttpHeaders({'Content-Type': 'application/json', 'CDCAPI-SCode': environment.sCode});

    return this.http.get<any>(environment.apiURL + 'printinvoice/' + chamberId + '/' + invoiceId , {headers: callHeaders})
    .toPromise()
    .then(response => response)
    .catch(error => Promise.reject('Désolé! La facture est introuvable...'));
  }

  postDiscountCode(invoiceToken: string, chamberId: string, discountCode: string): Promise<any> {
    return this.http.post<any>(environment.apiURL + 'Invoice/' + invoiceToken + '/discountcode/' + discountCode + '?chamberid=' + chamberId, null, {headers: this.headers})
    .toPromise()
    .then(response => response)
    .catch(error => Promise.reject(error));
  }

  getReceiptPDF(invoiceId: string, chamberId: string): Promise<any> {
    const callHeaders = new HttpHeaders({'Content-Type': 'application/json', 'CDCAPI-SCode': environment.sCode});

    return this.http.get<any>(environment.apiURL + 'printreceipt/' + chamberId + '/' + invoiceId , {headers: callHeaders})
    .toPromise()
    .then(response => response)
    .catch(error => Promise.reject('Désolé! Le reçu est introuvable...'));
  }

  public getDateFromMS(dateString: string) {
    return new Date(parseInt((dateString.replace('/Date(', '')), 10));
  }
}



// WEBPACK FOOTER //
// /home/ubuntu/MembriPay/src/app/services/invoice.service.ts